import { Box, Text } from '@wix/design-system';
import { UserContactsSection } from '@wix/wix-help-widget-common/homepage';
import { useTranslation } from '@wix/wix-i18n-config';
import { Time } from '@wix/wix-ui-icons-common';
import React, { FC, useEffect, useMemo, useState } from 'react';

import { TLocalesKeys } from '../../../types';
import { userContactsDataHooks } from './UserContacts.dataHooks';

type UserContactsEmailProps = Pick<UserContactsSection, 'timeZone'>;

const updatingTimeInterval = 1000;

export const UserContactsTime: FC<UserContactsEmailProps> = ({ timeZone }) => {
  const { t } = useTranslation();
  const timeFormatter = useMemo(
    () =>
      new Intl.DateTimeFormat('en-US', {
        timeZone,
        hour: 'numeric',
        minute: 'numeric',
      }),
    [timeZone],
  );
  const [userLocalTime, setUserLocalTime] = useState(
    timeFormatter.format(Date.now()),
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      const time = timeFormatter.format(Date.now());
      setUserLocalTime(time);
    }, updatingTimeInterval);

    return () => clearInterval(intervalId);
  }, [timeFormatter]);

  return (
    <Box gap={2}>
      <Time fill="#116DFF" size={18} />
      <Text size="small" dataHook={userContactsDataHooks.localTime()}>
        {userLocalTime} ({t<TLocalesKeys>('home_contact_local_time')})
      </Text>
    </Box>
  );
};
